<template>
    <div class="row">
        <div class="col-12">
            <FormInput placeholder="Buscar..." v-model="search" />
        </div>
        <div class="col-12 tabla-sectores">
            <div class="table-responsive">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th></th>
                            <th>{{ $t('general.sector') }}</th>
                        </tr>
                    </thead>
                    <tbody v-if="zonas">
                        <template v-for="(zona, index) in zonas">
                            <tr :key="index" @click="goTo(2, zona)" v-if="zona.esta_disponible">
                                <td :style='"background-color: " + zona.color'></td>
                                <td>{{ zona.name }}</td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="4">
                                <LoaderComponent></LoaderComponent>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['zonas'],
        data() {
            return {
                search: null
            }
        },
        methods: {
            goTo(paso, zona) {
                this.$emit('goTo', paso, zona);
            }
        },
    }
</script>

<style>
    .tabla-sectores {
        overflow: scroll;
        height: 400px;
    }
</style>
